import React, { useCallback } from "react";
import { createPortal } from "react-dom";
import { Card, CardBody } from "reactstrap";

const NewMarketDropdownMenu = ({ containerType, searchParam, setSearchParam, data, closeDropmenu, top, left, width }) => {
  const filterData = data.filter(element => element !== searchParam);

  const onRowClickEventHandler = useCallback(
    e => {
      e.stopPropagation();
      const choosenValue = e.target.textContent.trim();
      setSearchParam(choosenValue);
      const select = document.getElementById(`${containerType}`);
      select.textContent = choosenValue;
      closeDropmenu();
    },
    [setSearchParam, closeDropmenu]
  );

  return createPortal(
    <div className={`${containerType}`} style={{ top: top, left: left, width: width }}>
      <Card>
        <CardBody>
          <table className="table">
            <tbody>
              {/* <tr>
                {this.props.isExpiration ?  <td>All expirations</td> : null}
              </tr> */}
              {filterData.map(element => {
                return (
                  <tr key={element} onClick={onRowClickEventHandler}>
                    <td className="singleOption">{element}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </CardBody>
      </Card>
    </div>,
    document.getElementById("root")
  );
};

export default NewMarketDropdownMenu;

// class NewMarketDropdownMenu extends React.Component {
//   constructor(props) {
//     super(props);
//   }

//   componentDidMount() {
//     // Array.from(document.querySelectorAll(`.${this.props.containerType}`)).forEach(el => {
//     Array.from(document.querySelectorAll(`.${this.props.containerType} tr`)).forEach(el => {
//       el.addEventListener("click", event => {
//         const choosenValue = event.target.textContent.trim();
//         this.props.setSearchParam(choosenValue);
//         const select = document.getElementById(`${this.props.containerType}`);
//         select.textContent = choosenValue;
//         this.props.closeDropmenu();
//       });
//     });
//   }

//   displayFilterData = () => {
//     const filterData = this.props.data.filter(element => element !== this.props.searchParam);
//     return filterData.map(element => {
//       return (
//         <tr key={element}>
//           <td className="singleOption">{element}</td>
//         </tr>
//       );
//     });
//   };

//   render() {
//     return createPortal(
//       <div className={`${this.props.containerType}`} style={{ top: this.props.top, left: this.props.left, width: this.props.width }}>
//         <Card>
//           <CardBody>
//             <table className="table">
//               <tbody>
//                 {/* <tr>
//                 {this.props.isExpiration ?  <td>All expirations</td> : null}
//               </tr> */}
//                 {this.displayFilterData()}
//               </tbody>
//             </table>
//           </CardBody>
//         </Card>
//       </div>,
//       document.getElementById("root")
//     );
//   }
// }

// NewMarketDropdownMenu.propTypes = {
//   // openedTradePositions: PropTypes.array
// };

// function mapStateToProps(state) {
//   return {
//     //   openedTradePositions: openedTradePositionsSelector(state)
//   };
// }

// export default connect(mapStateToProps)(NewMarketDropdownMenu);
